import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import React, { useState } from "react";
import { NavigateAction } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useNavigate } from "react-router-dom";
import { appPaths } from "../../../../constants/paths";
import { DisclosureHost } from "../../../../hooks/use-disclosure";
import { ViewType } from "../../../../pages/app/provider/scheduling/SchedulingLayout";
import Flex from "../../../Flex";
import ToggleTabs, { ToggleTabItem } from "../../../ToggleTabs";
import { useRoleController } from "../../../useRoleController";
import CustomTitle from "../../CustomTitle";
import {
  DEFAULT_SECONDARY_TEXT_COLOR,
  DEFAULT_TEXT_COLOR,
} from "../../../../utils/utils";
// import StyledButtonV2 from "../../StyledButtonV2";
import StyledButtonV2 from "../../StyledButtonV2";
import FilterSelect from "../../../FilterSelect";
import { PRIMITIVE } from "../../../ds";
import PendingInquiriesCount from "./PendingInquiriesCount";

interface ToolBarProps {
  label: string;
  onNavigate: (navigate: NavigateAction) => void;
  view?: ViewType;
  handleChangeView?: (view: ViewType) => void;
  isCollapse?: boolean;
  newAppointmentDisclosure: DisclosureHost;
  InstantAppointment: DisclosureHost;
  onFilterClick?: () => void;
  selectedProviders?: any;
}

type CalendarType = "calendar" | "appointment_list";

const CALENDAR_TOGGLE_TABS: ToggleTabItem<CalendarType>[] = [
  {
    value: "appointment_list",
    icon: (
      <Box component="img" src="/list.svg" sx={{ width: 15, height: 15 }} />
    ),
  },
  {
    value: "calendar",
    icon: (
      <Box component="img" src="/calendar.svg" sx={{ width: 15, height: 15 }} />
    ),
  },
];

const ToolBar = (props: ToolBarProps) => {
  const [calendarType, setCalendarType] = useState<CalendarType>(
    location.pathname?.includes(appPaths.schedulingAppointment)
      ? "appointment_list"
      : "calendar"
  );

  const navigate = useNavigate();

  function handleCalendarTypeChange(newType: CalendarType) {
    setCalendarType(newType);
    if (newType === "calendar") {
      navigate(appPaths.schedulingCalendar);
    } else {
      navigate(appPaths.schedulingAppointment);
    }
  }

  const { hasUpdate: hasAppointmentSchedulingUpdate } = useRoleController(
    "Appointment Scheduling"
  );
  const { hasUpdate: hasUpdateInstantAppointment } = useRoleController(
    "Instant Appointment"
  );

  return (
    <Flex justifyContent={"space-between"}>
      <Flex alignItems={"center"} justifyContent={"left"} gap={"10px"}>
        {props.isCollapse && (
          <Flex display={"flex"} alignItems={"center"}>
            <Box
              component="img"
              src="/filter.svg"
              sx={{
                cursor: "pointer",
                width: "15px",
                height: "11.88px",
                marginRight: "10.5px",
              }}
              onClick={props?.onFilterClick}
            />
            <CustomTitle
              color={"primary"}
              sx={{ cursor: "pointer" }}
              onClick={props?.onFilterClick}
            >
              Filters
            </CustomTitle>
          </Flex>
        )}

        {props?.view === "day" && (
          <Button
            variant="outlined"
            sx={{
              color: DEFAULT_TEXT_COLOR,
              borderColor: DEFAULT_SECONDARY_TEXT_COLOR,
            }}
            onClick={() => props.onNavigate("TODAY")}
          >
            Today
          </Button>
        )}

        <IconButton
          sx={{ color: DEFAULT_TEXT_COLOR }}
          onClick={() => props.onNavigate("PREV")}
        >
          <ChevronLeft />
        </IconButton>
        <Typography
          sx={{
            color: DEFAULT_TEXT_COLOR,
            letterSpacing: "-0.17px !important",
            fontSize: "16px",
            fontWeight: "500",
            lineHeight: "25.6px",
          }}
        >
          {props.label}
        </Typography>
        <IconButton
          sx={{
            color: DEFAULT_TEXT_COLOR,
          }}
          onClick={() => props.onNavigate("NEXT")}
        >
          <ChevronRight />
        </IconButton>
      </Flex>
      <Flex alignItems={"center"} justifyContent={"center"} gap={"20px"}>
        <PendingInquiriesCount />
        {/* {!location.pathname?.includes(appPaths.schedulingAppointment) && ( */}

        <Box width={"120px"}>
          <FilterSelect
            disableSortOptions
            clearable={false}
            options={[
              { value: "day", label: "Day" },
              { value: "week", label: "Week" },
              { value: "month", label: "Month" },
            ]}
            value={props.view}
            onChange={(val) => {
              props?.handleChangeView?.(val as ViewType);
            }}
          />
        </Box>
        {/* )} */}
        <ToggleTabs<CalendarType>
          tabs={CALENDAR_TOGGLE_TABS}
          activeTab={calendarType}
          onTabChange={handleCalendarTypeChange}
          containerSx={{
            border: "none",
            borderBottom: "none",
            backgroundColor: "transparent",
            padding: 0,
          }}
        />

        {hasAppointmentSchedulingUpdate && (
          <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
              <React.Fragment>
                <StyledButtonV2
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ marginTop: "2px" }}
                  {...bindTrigger(popupState)}
                  label={"Schedule Appointment"}
                />

                <Menu {...bindMenu(popupState)}>
                  <MenuItem
                    onClick={props.newAppointmentDisclosure.open}
                    sx={MenuFontSize}
                  >
                    New Appointment
                  </MenuItem>
                  {hasUpdateInstantAppointment && (
                    <MenuItem
                      onClick={props.InstantAppointment.open}
                      sx={MenuFontSize}
                    >
                      Instant Appointment
                    </MenuItem>
                  )}
                  {/* <MenuItem disabled>Block Appointment</MenuItem> */}
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
        )}
      </Flex>
    </Flex>
  );
};

export default ToolBar;

const MenuFontSize = { fontSize: `${PRIMITIVE.typography.fontSize.body.b5}px` };
